import gql from 'graphql-tag'

export default gql`
  mutation deleteOrganisation($id: String!) {
    deleteOrganisation(id: $id) {
        id
    }
  }
`
